import { Link as RouterLink } from 'react-router-dom';
import { Box, Text } from '@/ui';
import {
  appSidebarBrandLogoSx,
  appSidebarBrandWordmarkGroupSx,
  appSidebarBrandWordmarkTextSx,
  buildAppSidebarBrandRootSx,
} from './AppSidebarBrand.styles';
import type { ReactElement } from 'react';

type AppSidebarBrandProps = {
  collapsed?: boolean;
};

export const AppSidebarBrand = ({ collapsed = false }: AppSidebarBrandProps): ReactElement => (
  <Box
    component={RouterLink}
    to="/execution-runs"
    aria-label="FlowQA home"
    sx={buildAppSidebarBrandRootSx(collapsed)}
  >
    <Box component="img" src="/logo.png" alt="" sx={appSidebarBrandLogoSx} />
    {collapsed ? null : (
      <Box sx={appSidebarBrandWordmarkGroupSx}>
        <Text role="sectionTitle" component="span" sx={appSidebarBrandWordmarkTextSx}>
          FlowQA
        </Text>
      </Box>
    )}
  </Box>
);
